import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import ErrorBoundary from "./components/ErrorBoundary";
import LandingPage from "./pages/LandingPage";
import KontaktPage from "./pages/KontaktPage";
import ServicePage from "./pages/ServicePage";
import YdelserPage from "./pages/YdelserPage";
import LegalPage from "./pages/LegalPage";
import CookieConsent from "./components/CookieConsent";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, anchors: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-white text-slate-900 antialiased">
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/ydelser" element={<YdelserPage />} />
            <Route path="/ydelser/:slug" element={<ServicePage />} />
            <Route path="/privatlivspolitik" element={<LegalPage />} />
            <Route path="/cookiepolitik" element={<LegalPage />} />
            <Route path="/vilkaar" element={<LegalPage />} />
          </Routes>
          <CookieConsent />
          <Footer />
          <MobileCTA />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;